<!-- 连接用户 -->
<template>
  <div class="analysisContainer">

    <div class="card-head">
      <span class="title">连接用户分布</span>
      <el-dropdown trigger="click" @command="industryClick">
          <span class="el-dropdown-link">
            {{ "行业:"+industryData.category_name }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,index) in industry" :command="item" :key="index">{{item.category_name}}</el-dropdown-item>
          </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div class="tab-card-group">
      <div class="tab-card-item link-card"
        :class="currentActiveTabIndex === 0?'is-active':''"
        @click="switchActiveCard(0)">
        <div class="relative-ratio">
          <span class="ratio-label">30天环比</span>
        <span class="ratio-value decline" v-if="!linkCard?.link_struct || !linkCard?.link_struct?.['5']">-</span>
            <span class="ratio-value decline" v-else
                  :class="linkCard?.link_struct['5'].relative_ratio>0 ? 'colorRed':'colorGreen'">
              {{linkCard?.link_struct['5'].relative_ratio > 0?'+ ':''}}
              {{fmt(linkCard?.link_struct['5'].relative_ratio*100, {micrometer: true})||'-'}}%
            </span>
        </div>

        <div class="link-info">
          <span class="icon-tooltip-label link-label">
            <span class="text">连接用户数</span>
          </span>
            <el-tooltip content="近30天有效观看了视频的全部用户数" placement="top" >
            <i class="iconfont icon-19ad-icon-tooltip"></i>
            </el-tooltip>
          <div class="link-value">{{fmt(linkCard?.link_struct['5'].value, {micrometer: true})||'-'}}</div>
        </div>
      </div>

      <div class="tab-card-item link-card"
        :class="currentActiveTabIndex === 1?'is-active':''"
        @click="switchActiveCard(1)">
        <div class="relative-ratio">
          <span class="ratio-label">30天环比</span>
          <span class="ratio-value decline" v-if="!linkCard?.link_struct['1']">-</span>
          <span class="ratio-value decline" v-else :class="linkCard?.link_struct['1'].relative_ratio>0 ? 'colorRed':'colorGreen'">
            {{linkCard?.link_struct['1'].relative_ratio > 0?'+ ':''}}
            {{fmt(linkCard?.link_struct['1'].relative_ratio*100, {micrometer: true})||'-'}}%
          </span>
        </div>
        <div class="link-info">
          <span class="icon-tooltip-label link-label">
            <span class="text">了解</span>
          </span>
            <el-tooltip content="近30天仅观看了达人视频1次的用户数" placement="top" >
                <i class="iconfont icon-19ad-icon-tooltip"></i>
            </el-tooltip>
            <div class="link-value">{{fmt(linkCard?.link_struct['1'].value, {micrometer: true})||'-'}}</div>
        </div>
      </div>

      <div class="tab-card-item link-card"
        :class="currentActiveTabIndex === 2?'is-active':''"
        @click="switchActiveCard(2)">
        <div class="relative-ratio">
          <span class="ratio-label">30天环比</span>
          <span class="ratio-value decline" v-if="!linkCard?.link_struct['2']">-</span>
          <span class="ratio-value decline" v-else :class="linkCard?.link_struct['2'].relative_ratio>0 ? 'colorRed':'colorGreen'">
            {{linkCard?.link_struct['2'].relative_ratio > 0?'+ ':''}}
            {{fmt(linkCard?.link_struct['2'].relative_ratio*100, {micrometer: true})||'-'}}%
          </span>
        </div>
        <div class="link-info">
          <span class="icon-tooltip-label link-label">
            <span class="text">兴趣</span>
          </span>
          <el-tooltip content="近30天与达人互动的用户数" placement="top" >
            <i class="iconfont icon-19ad-icon-tooltip"></i>
          </el-tooltip>
          <div class="link-value">{{fmt(linkCard?.link_struct['2'].value, {micrometer: true})||'-'}}</div>
        </div>
      </div>

      <div class="tab-card-item link-card"
        :class="currentActiveTabIndex === 3?'is-active':''"
        @click="switchActiveCard(3)">
        <div class="relative-ratio">
          <span class="ratio-label">30天环比</span>
          <span class="ratio-value decline" v-if="!linkCard?.link_struct['3']">-</span>
          <span class="ratio-value decline" v-else :class="linkCard?.link_struct['3'].relative_ratio>0 ? 'colorRed':'colorGreen'">
            {{linkCard?.link_struct['3'].relative_ratio > 0?'+ ':''}}
            {{fmt(linkCard?.link_struct['3'].relative_ratio*100, {micrometer: true})||'-'}}%
          </span>
        </div>
        <div class="link-info">
          <span class="icon-tooltip-label link-label">
            <span class="text">喜欢</span>
          </span>
          <el-tooltip placement="top" content="近30天内对达人有持续关注的用户数">
          <i class="iconfont icon-19ad-icon-tooltip"></i>
          </el-tooltip>
          <div class="link-value">{{fmt(linkCard?.link_struct['3'].value, {micrometer: true})||'-'}}</div>
        </div>
      </div>

      <div class="tab-card-item link-card"
        :class="currentActiveTabIndex === 4?'is-active':''"
        @click="switchActiveCard(4)">
        <div class="relative-ratio">
          <span class="ratio-label">30天环比</span>
          <span class="ratio-value decline" v-if="!linkCard?.link_struct['4']">-</span>
          <span class="ratio-value decline" v-else :class="linkCard?.link_struct['4'].relative_ratio>0 ? 'colorRed':'colorGreen'">
            {{linkCard?.link_struct['4'].relative_ratio > 0?'+ ':''}}
            {{fmt(linkCard?.link_struct['4'].relative_ratio*100, {micrometer: true})||'-'}}%
          </span>
        </div>
        <div class="link-info">
          <span class="icon-tooltip-label link-label">
            <span class="text">追随</span>
          </span>
          <el-tooltip placement="top">
            <!-- slot="content"-->
           <div slot="content" class="text-tips-content">
            <span>近30天内对达人有追随行为的用户数,</span>
           </div>
          <i class="iconfont icon-19ad-icon-tooltip"></i>
          </el-tooltip>
          <div class="link-value">{{fmt(linkCard?.link_struct['4'].value, {micrometer: true})||'-'}}</div>
        </div>
      </div>
    </div>

    <div class="card-panel block-wrap">
       <!-- 连接用户趋势 折线图  -->
       <div class="top">
          <h5>{{trendNames[currentActiveTabIndex]}}用户趋势</h5>
        </div>
        <div class="base-chart" v-loading="loadingObj.userTrendsInfo">
          <div class="userTrendsInfo">
            <Bar :info="userTrendsInfo"></Bar>
          </div>
        </div>
    </div>

    <div class="card-panel user-connect-wrap block-wrap">
       <!-- 连接用户 -->
       <div class="top">
          <h5>连接用户</h5>
       </div>

       <div class="content-container" v-loading="loadingObj.updateConnectUserChart">
          <div class="flex-box">
              <!-- 漏斗图 -->
            <div class="user-connect-chart-wrap">
              <FunnelChart :chartInfo="connectUserChartInfo" ref="connectUserChartRef"></FunnelChart>
              <div class="label-group">
                  <div class="label-container">
                      <div class="label">
                          <span class="dot"></span>
                          了解
                      </div>
                      <div class="value">{{fmt(linkStruct?.link_struct['1'].proportion*100, {micrometer: true})||'-'}}%</div>
                      <div class="value">{{changeW(linkStruct?.link_struct['1'].value)}}w</div>
                  </div>
                  <div class="label-container">
                      <div class="label">
                          <span class="dot"></span>
                          兴趣
                      </div>
                      <div class="value">{{fmt(linkStruct?.link_struct['2'].proportion*100, {micrometer: true})||'-'}}%</div>
                      <div class="value">{{changeW(linkStruct?.link_struct['2'].value)}}w</div>
                  </div>
                  <div class="label-container">
                      <div class="label">
                          <span class="dot"></span>
                          喜欢
                      </div>
                      <div class="value">{{fmt(linkStruct?.link_struct['3'].proportion*100, {micrometer: true})||'-'}}%</div>
                      <div class="value">{{changeW(linkStruct?.link_struct['3'].value)}}w</div>
                  </div>
                  <div class="label-container">
                      <div class="label">
                          <span class="dot"></span>
                          追随
                      </div>
                      <div class="value">{{fmt(linkStruct?.link_struct['4'].proportion*100, {micrometer: true})||'-'}}%</div>
                      <div class="value">{{changeW(linkStruct?.link_struct['4'].value)}}w</div>
                  </div>
              </div>
            </div>
          </div>
          <div class="right">
              <div class="flex-box">
                  <div class="type-title">{{linkStruct?.author_link_type}}型达人</div>
                  <el-tooltip placement="top" content="该类达人,近30天的所有受众中，与达人进行深度互动达到【喜欢】层级的受众占比较高,这部分观众更容易被达人种草。">
                    <i class="iconfont icon-19ad-icon-tooltip"></i>
                  </el-tooltip>
              </div>
              <section>
                  <div class="section-title">总结</div>
                  <p> 月度连接总用户数 <strong> {{addThousandsSeparator(changeW(linkCard?.link_struct['5'].value))}}w，环比 {{fmt(linkCard?.link_struct['5'].relative_ratio*100, {micrometer: true})}}% </strong></p>
                  <p> 位于行业内 <strong>{{handleRankPercent(linkStruct?.link_struct?.['5']?.rank_percent)}}</strong></p>
              </section>
              <section>
                  <div class="section-title">连接用户类型</div>
                  <!-- 年龄 type:2  性别 type:1  城市 type:32 -->
                  <!-- <p> 触达用户 <strong>{{ distributionsData1.image.join(',') }}，{{ distributionsData0.image.join(',') }}</strong></p>
                  <p> 集中 <strong>{{ distributionsData2.image.join(',') }}</strong></p>   -->
                  <p> 触达用户 <strong>{{ userAge}}，{{ gender }}</strong></p>
                  <p> 主要分布 <strong>{{ cityLevel}}</strong></p>
              </section>
          </div>
       </div>
    </div>

    <div class="card-panel connect-user-warp block-wrap" v-loading="loadingObj.userSource">
      <!-- 连接用户来源 -->
      <div class="top">
          <h5>连接用户来源</h5>
      </div>
      <div class="user-source-chart-group">
        <div class="chart-card">
            <span class="title">流量来源</span>
            <div class="base-chart">
              <PieChart :chartInfo="userSourceChartInfo"
              :onClick="userSourceChartOnClick"
              ref="userSourceChartRef"></PieChart>
            </div>
        </div>
      </div>
      <div class="user-source-chart-group">
        <div class="chart-card">
              <div class="chart-header">
                <span class="title">内容一级标签</span>
                <span class="selected-name">已选：{{ userSourceChartInfo.data? userSourceChartInfo.data[userSourceSelectedIndex].name:"-" }}</span>
              </div>
              <div class="base-chart">
                <Bar :info="level1ChartInfo" @xAxisClick="xAxisClick"></Bar>
              </div>
          </div>
      </div>
      <div class="user-source-chart-group">
        <div class="chart-card">
              <div class="chart-header"><span
                  class="title">内容二级标签</span>
                  <span class="selected-name">已选：{{ subText || "-" }}</span>
              </div>
            <div class="base-chart">
              <Bar :info="level2ChartInfo"></Bar>
            </div>
          </div>
      </div>
    </div>

      <AudiencePortrait class="block-wrap"></AudiencePortrait>

    <!-- 相似达人模块-->
    <!-- <div class="part6" v-if="isShowSamedaren">
          <div class="bottemList">
            <div class="title">
                <div class="titleLeft"><i>{{darenName?darenName:''}}</i>相似达人推荐</div>
                <div style="display:none;" class="titleRight"><i class="reflesh"></i>刷新一下</div>
            </div>
            <ul class="sameList">
                <li v-for="(item,i) in sameDaren" :key="i">
                    <a :toHref="item.author_id" href="javascript:void(0);" @click="sameListClick">
                        <div class="top">
                            <div class="nameWrap">
                                <span>{{item.nick_name}}</span>
                                <div></div>
                                <i v-for="(u,v) in item.tags_content" :key="v">{{u}}</i>
                            </div>
                            <div class="imgWrap">
                                <img :src="item.avatar_uri" alt="">
                            </div>
                        </div>
                        <div class="center">
                            <div class="centerItem">
                                <span>{{(item.follower/10000).toFixed(1)}}w</span>
                                <p>粉丝数</p>
                            </div>
                            <div class="centerItem">
                                <span>{{item.expected_cpm}}</span>
                                <p>预期CPM</p>
                            </div>
                            <div class="centerItem">
                                <span>{{(item.author_score/10000).toFixed(1)}}</span>
                                <p>星图指数</p>
                            </div>
                        </div>
                        <div class="tag">
                            <span v-for="(x,b) in item.recommend_types" :key="b">{{x}}</span>
                        </div>
                        <div class="hr"></div>
                        <div class="bottem">
                            <span class="price">￥{{item.min_price}}</span>
                            <div class="other">
                                <i></i>详情
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div> -->
  </div>

</template>

<script>
import AudiencePortrait from "../AudiencePortrait/AudiencePortrait.vue";
import FunnelChart from "../../../components/Echart/FunnelChart.vue";
import PieChart from "../../../components/Echart/PieChart.vue";
import Bar from  "../../../components/newEchart/Bar.vue"
export default {
  name: "Analysis",
  props:['darenName'],
  data(){
    return {
      trendNames:["连接","了解","兴趣","喜欢","追随"],
      userTrendsInfo:{},
      //相似达人
      // sameDaren:{},
      // isShowSamedaren:false,
      // pageSameDarenRec:{},
      pageDarenFansFlag:true,
      pageDarenFans:'',
      pageDarenFans7:'',
      pageDarenFans30:'',
      pageDarenFans90:'',
      pageGetDarenFansdist:'',
      pageGetDarenWfan:'',
      pageDarenInfo:'',
      darenID:'',
        //时间
      timeInfo:{
          day_1:'',
          day_7:'',
          day_30:'',
          day_90:''
      },
      tab1Position: '总量',
      tab2Position: '近7天',
      portraitName:'观众画像',
      fansNumChart:{//粉丝趋势折线图信息
          nodeId:'fansNum',//节点
          data: [41.69, 41.7, 41.8, 41.75, 41.75, 41.85, 41.68, 41.75, 41.75, 41.85, 41.68],//数据
          smooth:true,//平滑
          xAxisData:['08-05', '08-06', '08-07', '08-08', '08-09', '08-10', '08-11', '08-12', '08-12', '08-12', '08-19'],//x轴的数据
          min:41.65, //y轴的最小值
          max:41.9, //y轴最大值
          interval:0.05, //y轴值之间的间隔
          yAxisName:'粉丝人数',
          tooltipName:'粉丝总量',
          unit:''
      },
      fansData:{},
      darenFansdist:{},
      linkDistributionData:{},
      distributionsData0:{},
      distributionsData1:{},
      distributionsData2:{},
      gender:{},
      userAge:{},
      cityLevel:{},
      // dododo
      currentActiveTabIndex: 0,
      industryClickDisabled: false,
      linkStruct:{
        link_struct:{'1':{},'2': {},'3': {},'4': {}}
      },
      linkCard:{
        link_struct:{'1':{},'2': {},'3': {},'4': {},'5':{}}
      },
      authorTouchdistData:{},
      dailyFansData:{},
      linkDailyData:{},
      // dailyFansCompleted:false,
      // linkDailyCompleted:false,

      industry:[],//行业信息
      industryData:{
          category_id:0,
          category_name:'不限'
      },
      trendChartInfo:{
        nodeId:"trendChart",
        //这个data固定长度是2
        data:[[],[]]
      },
      connectUserChartInfo:{
        nodeId:"connectUserChart",
        data:[[],[]]
      },
      userSourceChartInfo:{
        nodeId:"userSourceChart",
        data:[[],[]]
      },
      level1ChartInfo:{},
      level2ChartInfo:{
        nodeId:"level2Chart",
        data:[]
      },
      userSourceSelectedIndex:0,
      userSourceSelectedIndexSub:0,
      subText:'',
      loadingObj: {
        userSource: false,
        userTrendsInfo: false, //连接用户折线图
        updateConnectUserChart: false, //连接用户漏斗图
      }
    }
  },
  computed:{

  },
  methods:{
      xAxisClick(data){
      this.subText = data.name
      this.userSourceSelectedIndexSub = data.dataIndex;
      this.updateUserSourceChart();
      },
      //   获取账号连接用户趋势
      async getLinkDaily(){
       await this.$api.getData.getLinkDaily(`/${this.darenID}?platform_channel=1&industry_id=${this.industryData.category_id}&link_type=${this.convertActive()}`)
        .then((res) => {
          this.linkDailyData = res.data.data
          // this.linkDailyCompleted = true;
          // this.updateTrendChart()
        })
      },
      //   获取账号粉丝趋势
      async getDailyFans(){
        await this.$api.getData.getDailyFans(`/${this.darenID}?platform_channel=1&industry_id=${this.industryData.category_id}&link_type=${this.convertActive()}`)
          .then((res) => {
            this.dailyFansData = res.data.data
            // this.dailyFansCompleted = true;
            // this.updateTrendChart()
        })
      },
    sameListClick(e){
        let inSalesGroup=window.sessionStorage.getItem('inSalesGroup')
        let name=window.sessionStorage.getItem('name')
        window.sessionStorage.clear()
        window.sessionStorage.setItem('inSalesGroup',inSalesGroup)
        window.sessionStorage.setItem('name',name)
        let routeData = this.$router.resolve({
            path: '/daren',
          query: {
              id: e.currentTarget.getAttribute("tohref")
          }
        })
        window.open(routeData.href, "_blank");
    },
    // create10(){
    //     this.sameDaren = this.pageSameDarenRec
    //     if(this.sameDaren){
    //         this.sameDaren.forEach(function(item){
    //             item.author_id =item.author_id
    //         })
    //         this.isShowSamedaren = true
    //     }
    //   },
    tab1Change(tab){
      this.tab1Position=tab
      this.changefanAddChart(this.tab1Position,this.tab2Position)
    },
    tab2Change(tab){
      this.tab2Position=tab
      this.changefanAddChart(this.tab1Position,this.tab2Position)
    },
    portraitTabClick(tab){
      if(tab.$el.id==="pane-观众画像"){
        this.portraitName="观众画像"
      }else if(tab.$el.id==="pane-粉丝画像"){
        this.portraitName="粉丝画像"
      }
    },
   changefanAddChart(tab1Position,tab2Position){
      //   7 30 90天 折线图
      if(tab2Position==='近7天'){
        if(JSON.parse(window.sessionStorage.getItem('getDarenFans7'))){
          this.pageDarenFans7= JSON.parse(window.sessionStorage.getItem('getDarenFans7')).data.data
          let data = this.pageDarenFans7
          this.fansData = this.pageDarenFans7
          this.changefanAddChartMethord(tab1Position,data)
        }else{
          // this.$api.getData.getDarenFans('/'+this.darenID,'day_count=7').then((res) => {
          //   window.sessionStorage.setItem('getDarenFans7',JSON.stringify(res));
          //   this.pageDarenFans7= JSON.parse(window.sessionStorage.getItem('getDarenFans7')).data.data
          //   let data = this.pageDarenFans7
          //   this.fansData = this.pageDarenFans7
          //   this.changefanAddChartMethord(tab1Position,data)
          // })
        }

      }else if(tab2Position==='近30天'){
        if(JSON.parse(window.sessionStorage.getItem('getDarenFans30'))){
            this.pageDarenFans30= JSON.parse(window.sessionStorage.getItem('getDarenFans30')).data.data
            let data = this.pageDarenFans30
            this.fansData = this.pageDarenFans30
            this.changefanAddChartMethord(tab1Position,data)
        }else{
          // this.$api.getData.getDarenFans('/'+this.darenID,'day_count=30').then((res) => {
          //   window.sessionStorage.setItem('getDarenFans30',JSON.stringify(res));
          //   this.pageDarenFans30= JSON.parse(window.sessionStorage.getItem('getDarenFans30')).data.data
          //   let data = this.pageDarenFans30
          //   this.fansData = this.pageDarenFans30
          //   this.changefanAddChartMethord(tab1Position,data)
          // })
        }

      }else if(tab2Position==='近90天'){
        if(JSON.parse(window.sessionStorage.getItem('getDarenFans90'))){
            // this.pageDarenFans90= JSON.parse(window.sessionStorage.getItem('getDarenFans90')).data.data
            // let data = this.pageDarenFans90
            // this.fansData = this.pageDarenFans90
            // this.changefanAddChartMethord(tab1Position,data)
        }else{
          // this.$api.getData.getDarenFans('/'+this.darenID,'day_count=90').then((res) => {
          //   window.sessionStorage.setItem('getDarenFans90',JSON.stringify(res));
          //   this.pageDarenFans90= JSON.parse(window.sessionStorage.getItem('getDarenFans90')).data.data
          //   let data = this.pageDarenFans90
          //   this.fansData = this.pageDarenFans90
          //   this.changefanAddChartMethord(tab1Position,data)
          // })
        }

      }
    },
   changefanAddChartMethord(tab1Position,data){
      let chartdata =[]
      let xAxisData =[]
      if(tab1Position==='总量'){
        data.daily?.forEach(function(item,i){
        xAxisData.push(item.date.substr(5,5))
            chartdata.push(item.fans_cnt)
        })
        this.fansNumChart.data=chartdata
        this.fansNumChart.xAxisData=xAxisData

        this.fansNumChart.unit=''
      }else if(tab1Position==='增量'){
        data.delta?.forEach(function(item,i){
        xAxisData.push(item.date.substr(5,5))
            chartdata.push(item.fans_cnt)
        })

        this.fansNumChart.data=chartdata
        this.fansNumChart.xAxisData=xAxisData
        this.fansNumChart.unit=''
        this.fansNumChart.yAxisName='增长人数'

      }
    },
    handleRankPercent(rankPercent){
        if(!rankPercent){
            return "-%"
        }
        let newRankPercent = this.fmt(rankPercent*100, {micrometer: true})
        let finalResult = ""
        if(newRankPercent>0 && newRankPercent<0.5){
            finalResult = "前0.5%"
        }else if(newRankPercent>0.5 && newRankPercent<3){
            finalResult = "前3%"
        }else if(newRankPercent>3 && newRankPercent<10){
            finalResult = "前10%"
        }else if(newRankPercent>10 && newRankPercent<20){
            finalResult = "前20%"
        }else if(newRankPercent>20 && newRankPercent<50){
            finalResult = "前50%"
        }else if(newRankPercent>50 && newRankPercent<70){
            finalResult = "低于50%"
        }else if(newRankPercent>70 && newRankPercent<100 || newRankPercent < 0){
            finalResult = "低于70%"
        }
        return finalResult

    },
    //获取行业信息
    async getAuthorIndustry(){
      await this.$api.getData.getAuthorIndustry().then((res) => {
          let data = res?.data?.data?.industry_categories
          this.industry = data?.map(x=>{
              return {category_id:x.category_id,category_name:x.category_name }
          })
          this.industry?.unshift({
              category_id:0,
              category_name:'不限'
          })
      })
    },
    //连接用户画像
    getLinkDistribution(){
      this.$api.getData.getLinkDistribution(`/${this.darenID}?platform_channel=1&link_type=${this.convertActive()}`)
      .then((res) => {
          this.linkDistributionData = res.data.data

          this.distributionsData0 = this.linkDistributionData?.distributions?.find(d=>d.type==1);
          this.distributionsData1 = this.linkDistributionData?.distributions?.find(d=>d.type==2);
          this.distributionsData2 = this.linkDistributionData?.distributions?.find(d=>d.type==32);
          this.gender=this.distributionsData0?.image?.join(',')
          this.userAge=this.distributionsData1?.image?.join(',')
          this.cityLevel=this.distributionsData2?.image?.join(',')
      })

    },

    industryClick(val){
      this.industryData = val
    },

    switchActiveCard(index){
      this.currentActiveTabIndex = index;

      // this.getDailyFans();
      // this.getLinkDaily();
      this.updateTrendChart()
    },
    userSourceChartOnClick(event){
      this.userSourceSelectedIndex = event.dataIndex;
      this.userSourceSelectedIndexSub = 0;
      this.updateUserSourceChart();
    },

    changeW(num){
       return (num/10000).toFixed(1)
    },
    //连接用户联动图表
    updateConnectUserChart(){
     this.connectUserChartInfo.data[0] = [
          {
              value: this.linkStruct?.link_struct['1'].value,
              name: '了解',
              itemStyle: {opacity: this.linkStruct?.link_struct['1'].value>0 ?1 :0}
          },
          {
              value: this.linkStruct?.link_struct['2'].value,
              name: '兴趣',
              itemStyle: {opacity: this.linkStruct?.link_struct['2'].value>0 ?1 :0}
          } ,
          {
              value: this.linkStruct?.link_struct['3'].value,
              name: '喜欢',
              itemStyle: {opacity: this.linkStruct?.link_struct['3'].value>0 ?1 :0}
          },
          {
              value: this.linkStruct?.link_struct['4'].value,
              name: '跟随',
              itemStyle: {opacity: this.linkStruct?.link_struct['4'].value>0 ?1 :0}
          }
         ]
         this.connectUserChartInfo.data[1] = [
          {
              value: this.linkStruct?.link_struct['1'].same_industry_median,
              name: '了解',
              itemStyle: {opacity: this.linkStruct?.link_struct['1'].same_industry_median>0 ?1 :0}
          },
          {
              value: this.linkStruct?.link_struct['2'].same_industry_median,
              name: '兴趣',
              itemStyle: {opacity: this.linkStruct?.link_struct['2'].same_industry_median>0 ?1 :0}
          },
          {
              value: this.linkStruct?.link_struct['3'].same_industry_median,
              name: '喜欢',
              itemStyle: {opacity: this.linkStruct?.link_struct['3'].same_industry_median>0 ?1 :0}
          },
          {
              value: this.linkStruct?.link_struct['4'].same_industry_median,
              name: '跟随',
              itemStyle: {opacity: this.linkStruct?.link_struct['4'].same_industry_median>0 ?1 :0}
          }
         ]

         this.$refs?.connectUserChartRef?.funnelChart(this.connectUserChartInfo)
         this.loadingObj.updateConnectUserChart = false
    },
    //更新用户来源
    updateUserSourceChart(){
      this.userSourceChartInfo.data = this.authorTouchdistData?.video_touch?.map(d=>{
        return {name:d.distribution_data.name, value:d.distribution_data.cnt}
      })
      let level1Data = this.authorTouchdistData?.video_touch[this.userSourceSelectedIndex]
      ?.second_distribution?.map(d=>{
        return {name:d.distribution_data.name, value:d.distribution_data.cnt,subData:d.three_distribution}
      }).sort((a, b) =>b.value - a.value).slice(0, 5);
      let sum1 = 0
      level1Data?.forEach(item=>{
         sum1+=item.value
        })
      let options1 = {
        xAxis: level1Data?.map(x=>x.name),
        data:[{
          name: '内容一级标签',
          data:level1Data?.map(x=>
          {
            return(x.value/sum1*100).toFixed(2)
          }),
          type: 'bar',
          symbol: 'none',
        }],
        custom: {
          tooltip: {
          show:true,
          // trigger: 'item',
          formatter: (data)=>{
            let dataObj = data[0]
            return `${dataObj.name}:${dataObj.value}%`
          }
        },
          grid: {
          right:'12',
        },
        series: [
          {
            itemStyle:
            {
              // 柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                normal: {
                  // 柱形图圆角，初始化效果
                  barBorderRadius:[5, 5, 5, 5],
                  show:true,
                  color:new this.$echarts.graphic.LinearGradient(
                    1, 0, 0, 1,
                    [
                      {offset: 0, color: '#4faefc'},
                      {offset: 1, color: '#187bfc'}
                    ]
                  ),
                  label: {
                    show: true,  //开启显示
                    position: 'right',  //在上方显示
                    textStyle: {  //数值样式
                      color: '#999',
                      fontSize: 12
                    },
                    formatter:function (params) {

                      var txt=params.value
                      if(txt>=10000){
                        txt = (txt/10000).toFixed(2)+'w'
                      }
                      return txt
                    },
                  },
               },
              },
              }
            ],
          xAxis: {
            triggerEvent: true,
            type: 'value',
            axisLabel: {
                formatter: "{value}%",
                interval:100
            }
          },
          yAxis: {
              inverse: true,
              type: 'category',
              data: level1Data?.map(x=>x.name),
          },
        }
      }
      this.level1ChartInfo = options1

      let level2Data = level1Data?.[this.userSourceSelectedIndexSub]?.subData?.map(d=>{
        return {name:d.distribution_data.name, value:d.distribution_data.cnt}
      }).sort((a, b) =>b.value - a.value).slice(0, 4);
      let sum2 = 0
      level2Data?.forEach(item=>{
         sum2+=item.value
        })
      let options2 = {
        xAxis: level2Data?.map(x=>x.name),
        data:[{
          name: '内容二级标签',
          data:level2Data?.map(x=>
          {
            return(x.value/sum2*100).toFixed(2)
          }),
          type: 'bar',
          symbol: 'none',
        }],
        custom: {
          tooltip: {
            show:true,
            // trigger: 'item',
            formatter:  (data)=>{
            let dataObj = data[0]
            return `${dataObj.name}:${dataObj.value}%`
          }
          },
          grid: {
          right:'12',
        },
          xAxis: {
          },
          yAxis: {
            axisLabel: {
                  formatter: "{value}%",
            }
          },
          series: [
          {
            itemStyle:
            {
              // 柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                normal: {
                  // 柱形图圆角，初始化效果
                  barBorderRadius:[5, 5, 5, 5],
                  show:true,
                  color:new this.$echarts.graphic.LinearGradient(
                    1, 0, 0, 1,
                    [
                      {offset: 0, color: '#4faefc'},
                      {offset: 1, color: '#187bfc'}
                    ]
                  ),
                  label: {
                    show: true,  //开启显示
                    position: 'top',  //在上方显示
                    textStyle: {  //数值样式
                      color: '#999',
                      fontSize: 12
                    },
                    formatter:function (params) {

                      var txt=params.value
                      if(txt>=10000){
                        txt = (txt/10000).toFixed(2)+'w'
                      }
                      return txt
                    },
                  },
               },
              },
              }
            ],
        }

      }
      this.level2ChartInfo = options2

      this.$refs?.userSourceChartRef?.pieChart(this.userSourceChartInfo);
      this.loadingObj.userSource = false
    },

    addThousandsSeparator(number) {
        // 将数字转换为字符串形式
        let numberStr = String(number);

        // 检查数字是否为负数
        let isNegative = false;
        if (numberStr.startsWith('-')) {
            isNegative = true;
            numberStr = numberStr.slice(1);
        }

        // 按照每三位加分隔符的规则处理数字
        const parts = numberStr.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        // 重新组合数字和符号
        let result = parts.join('.');
        if (isNegative) {
            result = '-' + result;
        }
        return result;
    },

     // 转换接口参数
    convertActive(){
      switch(this.currentActiveTabIndex){
        case 0: return 5;
        case 1: return 1;
        case 2: return 2;
        case 3: return 3;
        case 4: return 4;
      }
    },

    async updateTrendChart(){
      this.loadingObj.userTrendsInfo = true
      await this.getLinkDaily()
      await this.getDailyFans()
      // let trendChartInfoData = [[],[]]
      // if(!(this.linkDailyCompleted && this.dailyFansCompleted)) return
      let daily = this.dailyFansData?.daily
      let daily_cnt = this.linkDailyData?.link_daily_cnt
      let options = {
        xAxis: daily?.map(x=>x?.date?.substring(5))||[],
        data:[
          {
            name:`${this.trendNames[this.currentActiveTabIndex]}用户数`,
            data:daily_cnt?.map(x=>x?.value),
            type:"line",
            yAxisIndex: 0,
            smooth: true,
            symbol: "none",
            color:"#38a1ff",
            areaStyle: {
              color: "#38a1ff",
              opacity: 0.1
            }
          },
          {
            name:"粉丝数",
            data:daily?.map(x=>x?.fans_cnt),
            type:"line",
            yAxisIndex: 1,
            smooth: true,
            symbol: "none",
            color:"#ff5c00",
            areaStyle: {
              color: "#ccc",
              opacity: 0.2
            }
          },
        ],
        custom: {
          xAxis:{
            axisLabel:{
              interval:1
            }
          },
          grid: {
            top:80,
            bottom: 0,
            left: 20,
          },
          legend: {
            top:20,
            right: 0,
            icon: "circle",
            data: [`${this.trendNames[this.currentActiveTabIndex]}用户数`, "粉丝数"]
          },
          yAxis: [
            {
              type: 'value',
              name: `${this.trendNames[this.currentActiveTabIndex]}用户数`,
              max:Math.max.apply(null,daily_cnt?.map(x=>x?.value)),
              min:Math.min.apply(null,daily_cnt?.map(x=>x?.value)),
              axisLabel: {
                formatter: function (value) {
                  return parseInt(value / 10000) + "w";
                }
              }
            },
            {
              type: 'value',
              name: "粉丝数",
              max:Math.max.apply(null,daily?.map(x=>x?.fans_cnt)),
              min:Math.min.apply(null,daily?.map(x=>x?.fans_cnt)),
              axisLabel: {
                formatter: function (value) {
                  return parseInt(value / 10000) + "w";
                }
              }
            },
          ],
        }
      }
      this.userTrendsInfo = options
      let item = this.userTrendsInfo.data.find(x=>x.name=="粉丝数")
      let idx = this.userTrendsInfo.data.findIndex(x=>x.name=="粉丝数")
      let yAxisItem = this.userTrendsInfo.custom.yAxis.find(x=>x.name=="粉丝数")
      let yAxisIdx = this.userTrendsInfo.custom.yAxis.findIndex(x=>x.name=="粉丝数")
      if(this.convertActive()!==5){
        this.userTrendsInfo.data.splice(idx,1)
        this.userTrendsInfo.custom.yAxis.splice(yAxisIdx,1)
      }else{
        if(idx==-1){
          this.userTrendsInfo.data.push(item)
        }
        if(yAxisIdx==-1){
          this.userTrendsInfo.custom.yAxis.push(yAxisItem)
        }
      }
      this.loadingObj.userTrendsInfo = false
    },
    // getLinkCard获取 连接用户环比
    getLinkCard(){
      this.$api.getData.getLinkCard(`/${this.darenID}?platform_channel=1&industry_id=${this.industryData.category_id}`).then((res) => {
        this.linkCard = res.data.data
      })
    },
    // getLinkStruct获取 连接用户分布分 1-了解 2-兴趣 3-喜欢 4-追随 5-连接用户数...
    getLinkStruct(){
      this.loadingObj.updateConnectUserChart = true
      this.$api.getData.getLinkStruct(`/${this.darenID}?platform_channel=1&industry_tag=${this.industryData.category_id}`).then((res) =>{
        this.linkStruct = res.data.data
        this.updateConnectUserChart()
      })
    },
    // 连接用户趋势

  },
  components:{
    AudiencePortrait,
    FunnelChart,
    PieChart,
    Bar
  },
  watch:{
    "industryData.category_id":{
        handler(val){
        this.getAuthorIndustry()
        this.updateUserSourceChart()
        // this.updateConnectUserChart()
        this.getLinkDistribution()
        this.getLinkCard()
        this.getLinkStruct()
        this.updateTrendChart()
        // this.getDailyFans()
        // this.getLinkDaily()
        },
        deep:true,
    // immediate:true
    }
  },
  async created(){
    this.getAuthorIndustry()
    this.darenID = this.$route.query.id

    //   获取达人基础信息 时间
    if(window.sessionStorage.getItem('getDarenInfo')){
        this.pageDarenInfo= JSON.parse(window.sessionStorage.getItem('getDarenInfo')).data.data
        this.timeInfo.day_1 = this.pageDarenInfo.day_1
        this.timeInfo.day_7 = this.pageDarenInfo.day_7
        this.timeInfo.day_30 = this.pageDarenInfo.day_30
        this.timeInfo.day_90 = this.pageDarenInfo.day_90
    }else{
        this.$api.getData.getDarenInfo('/'+this.darenID).then((res) => {
            window.sessionStorage.setItem('getDarenInfo',JSON.stringify(res));
            this.pageDarenInfo= JSON.parse(window.sessionStorage.getItem('getDarenInfo')).data.data
            this.timeInfo.day_1 = this.pageDarenInfo.day_1
            this.timeInfo.day_7 = this.pageDarenInfo.day_7
            this.timeInfo.day_30 = this.pageDarenInfo.day_30
            this.timeInfo.day_90 = this.pageDarenInfo.day_90
        })
    }
       //  获取相似达人推荐
    // if(window.sessionStorage.getItem('getDarenCoope')){
    //        this.pageSameDarenRec= JSON.parse(window.sessionStorage.getItem('getSameDarenRec')).data.data
    //        this.create10()
    //     }else{
    //         this.$api.getData.getSameDarenRec('/'+this.darenID).then((res) => {
    //         window.sessionStorage.setItem('getSameDarenRec',JSON.stringify(res));
    //         this.pageSameDarenRec= JSON.parse(window.sessionStorage.getItem('getSameDarenRec')).data.data
    //         this.create10()
    //     })
    //  }

    this.$api.getData.getLinkStruct(`/${this.darenID}?platform_channel=1&industry_tag=${this.industryData.category_id}`).then((res) =>{
      this.linkStruct = res.data.data
      this.updateConnectUserChart();
    })


  this.changefanAddChart(this.tab1Position,this.tab2Position)


    if(window.sessionStorage.getItem('getDarenFansdist')){
            this.pageGetDarenFansdist= JSON.parse(window.sessionStorage.getItem('getDarenFansdist')).data.data
            this.darenFansdist = this.pageGetDarenFansdist

    }else{
       this.$api.getData.getDarenFansdist('/'+this.darenID).then((res) => {
            window.sessionStorage.setItem('getDarenFansdist',JSON.stringify(res));
            this.pageGetDarenFansdist= JSON.parse(window.sessionStorage.getItem('getDarenFansdist')).data.data
            this.darenFansdist = this.pageGetDarenFansdist
      })
    }
    //    获得达人的连接用户来源
    this.loadingObj.userSource = true
    if(window.sessionStorage.getItem('getAuthorTouchdist')){
           this.authorTouchdistData = JSON.parse(window.sessionStorage.getItem('getAuthorTouchdist')).data.data
           this.userSourceSelectedIndex = 0;
           this.userSourceSelectedIndexSub = 0;
           await this.updateUserSourceChart();
           this.subText = this.level1ChartInfo?.xAxis?.[0]||''
          }else{
            await this.$api.getData.getAuthorTouchdist(`/${this.darenID}?platform_channel=1`, false).then(async (res) => {
              window.sessionStorage.setItem('getAuthorTouchdist',JSON.stringify(res));
              this.authorTouchdistData = JSON.parse(window.sessionStorage.getItem('getAuthorTouchdist')).data.data
              this.userSourceSelectedIndex = 0;
              this.userSourceSelectedIndexSub = 0;
              await this.updateUserSourceChart();
              this.subText = this.level1ChartInfo?.xAxis?.[0]||''
      })
      this.loadingObj.userSource = false
    }
    this.getLinkStruct()
    this.getLinkCard()
    // this.getDailyFans()
    // this.getLinkDaily()
    this.updateTrendChart()
    this.getLinkDistribution()
  },
  mounted() {
    if(this.pageDarenFansFlag){
      this.pageDarenFansFlag = false
    }
    this.getAuthorIndustry();
  }
}
</script>


<style lang="less" scoped>
    .el-dropdown-menu{
    height: 350px;
    overflow: auto;
    }

</style>


<style scoped>
  /* 粉丝趋势折线图 */
  #fansNum{
    width: 100%;
    height: 288px;
  }

  #trendChart{
    width: 100%;
    height: 100%;
  }

  #connectUserChart{
    width: 100%;
    height: 100%;
  }

  #userSourceChart{
    width: 100%;
    height: 200px;
  }

  #level1Chart{
    width: 100%;
    height: 100%;
  }

  #level2Chart{
    width: 100%;
    height: 100%;
  }

  .portrait .hr{
    width: 804px;
    height: 0.5px;
    margin-top: 24px;
    margin-left: 30px;
    background: #F0F0F0;
  }
  .portrait .summary{
    border-top: 1px solid #F0F0F0;
    /* width: 802px; */
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 24px;
  }
  .portrait .summary i{
    display: block;
    height: 70px;
    line-height: 70px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .portrait .summary span{
    margin-right: 24px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .portrait .summary span:nth-of-type(1){
    margin-left: 9px;
  }

  /* todo */

  .link-info .icon-19ad-icon-tooltip{
  color: #8a8a8a;
  font-size: 14px;
  margin-left: 5px;
  }

  .analysisContainer .dispatchWarp{
    padding:0 24px 24px 24px;
    box-sizing: border-box;
    width: 100%;
    height: 440px;
    border-radius: 6px;
    background: #FFFFFF;
  }

  .analysisContainer .card-panel{
    width: 100%;
    padding: 0 24px 24px 24px;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
    margin-top: 16px;
  }
  .base-chart {
      width: 100%;
      height: 320px;
  }
  .card-head{
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 34px;
  }

  .card-head-right{
    display: inline-block;
    position: relative;
  }

  .card-head .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 34px;
  }

  .tab-card-group{
    display: flex;
    flex-wrap: nowrap;
  }
  .colorRed{
        margin-left: 8px;
        font-size: 12px;
        color: #ff5c00 !important;
    }
    .colorGreen{
        margin-left: 8px;
        font-size: 12px;
        color: #43D4B9 !important;
    }
  .tab-card-item:first-child {
    width: 232px;
    border-radius: 8px;
  }

  .tab-card-item{
    position: relative;
    padding: 12px;
    border: 1px solid transparent;
    background: #FFFFFF;
    cursor: pointer;
  }
  .tab-card-item:hover {
      z-index: 1;
      box-shadow: 0 0 15px rgba(0,0,0,.1);
  }

  .tab-card-item:not(:first-child), .tab-card-item[data-v-a8d337c3]:not(:last-child) {
    border-right: 1px solid #F0F0F0;
  }

  .tab-card-item:not(:first-child) {
    flex: 1;
  }

  .tab-card-item:nth-child(2) {
    margin-left: 12px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .tab-card-item.is-active {
    border-color: #ff5c00;
  }

  .link-card .relative-ratio {
    display: flex;
    justify-content: flex-end;
    font-size: 12px;
    line-height: 20px;
  }

  .link-card .link-info{
    margin-top: 20px;
    color: #333;
  }
  .link-card .link-info .link-label {
    font-weight: 500;
    font-size: 13px;
    line-height: 22px;
  }

  .icon-tooltip-label{
      display: inline-flex;
      align-items: center;
      vertical-align: middle;
  }

  .link-card .link-info .link-value[data-v-8c58c5d8] {
      font-family: OPPOSans;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
  }

  .link-card .relative-ratio .ratio-label {
    color: #c1c1c1;
    font-weight: 400;
  }

  .link-card .relative-ratio .ratio-value {
      margin-left: 2px;
      font-weight: 500;
  }

  .link-card .relative-ratio .decline {
      color: #0bb55a;
  }

  .user-source-chart-group {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    box-sizing: border-box;
  }

  .user-source-chart-group .chart-card {
    width: 100%;
    height: 230px;
    padding: 16px;
    border: 1px solid #F0F0F0;
    background-color: #fff;
    border-radius: 4px;
  }

  .user-source-chart-group .chart-card .title {
      color: #333;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
  }

  .user-source-chart-group .chart-card .chart-header {
      display: flex;
      justify-content: space-between;
  }

  .user-source-chart-group .chart-card .chart-header .selected-name {
      color: #666;
      font-weight: 400;
      font-size: 12px;
      line-height: 22px;
  }

  .user-source-chart-group .chart-card .base-chart {
      width: 100%; height: 230px;
  }

  .user-connect-wrap .user-connect-chart-wrap{
    width: 571px;
    height: 250px;
    margin-top: 26px;
    position: relative;
  }

  .user-connect-wrap .label-container {
      width: 25%;
      position: relative;
      padding: 10px;
  }

  .user-connect-wrap .label {
      cursor: auto;
      line-height: 100%;
      font-size: 12px;
      font-family: sans-serif;
      pointer-events: auto;
      text-align: left;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-bottom: 2px;
      color: #333;
      font-weight: 500;
  }

  .user-connect-wrap .dot {
      cursor: auto;
      line-height: 100%;
      font-size: 12px;
      font-family: sans-serif;
      pointer-events: auto;
      text-align: left;
      color: #333;
      font-weight: 500;
      box-sizing: border-box;
      width: 8px;
      height: 8px;
      margin-right: 6px;
      background-color: #38a1ff;
      border-radius: 50%;
  }

  .user-connect-wrap .value {
      cursor: auto;
      pointer-events: auto;
      text-align: left;
      box-sizing: border-box;
      font-size: 12px;
      line-height: 20px;
      color: #999;
      font-family: OPPOSans;
  }

  .user-connect-wrap .label-group{
    margin-top: 12px;
    display: flex;
    position: absolute;
    bottom: -20px;
    width: 100%;
  }

  .user-connect-wrap .content-container {
    margin-top: 16px;
    display: flex;
    width: 100%;
    height: 300px;
  }

  .user-connect-wrap .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 24px;
    padding: 0 24px;
    border: 1px solid #F0F0F0;
    color: #666;
    border-radius: 8px;
  }

  .user-connect-wrap .type-title {
      color: #ff5c00;
      font-weight: 500;
  }

  .user-connect-wrap .section-title {
      margin: 16px 0 8px;
      color: #333;
      font-weight: 500;
  }
  .flex-box{
      display: flex;
  }
  .analysisPart{
    width: 100%;
    height: 396px;
    padding: 0 30px;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
    margin-top: 16px;
  }
  .analysisContainer .top{
    width: 100%;
    height: 76px;
    box-sizing: border-box;
    border-bottom: 1px solid #F0F0F0;
  }
  .analysisContainer .top h5{
    display: inline-block;
    height: 76px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .analysisContainer .top i{
    display: inline-block;
    margin-left: 10px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #999999;
  }
  .analysisContainer .top .tab{
    float: right;
    margin-left: 16px;
    margin-top: 22px;
  }
  .analysisContainer>>>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
    color: #FF5C00;
    background-color: #FFF2EB;
    border-color: #FF5C00;
    box-shadow: -1px 0 0 0 #FF5C00;
  }
  .analysisContainer>>>.el-radio-button__inner:hover{
    color: #333;
  }
  .analysisContainer>>>.el-radio-button__inner{
    padding: 10px 16px;
  }
  .analysisContainer>>>.el-radio-button:first-child .el-radio-button__inner{
    border-radius: 2px 0 0 2px;
  }
  .analysisContainer>>>.el-radio-button:last-child .el-radio-button__inner{
    border-radius: 0 2px 2px 0;
  }

  .analysisContainer .portrait>>>.el-tabs__content{
    margin-top: 0;
  }
  .analysisContainer .portrait>>>.el-tabs__nav-wrap::after{
    height: 0;
  }
  .analysisContainer .portrait>>>.el-tabs__nav-scroll{
    padding-left: 30px;
  }
  .analysisContainer .portrait{
    width: 100%;
    margin-top:16px;
    background: #FFFFFF;
    border-radius: 6px;
  }
  .analysisContainer .portrait>>>.el-tabs__item{
    line-height:74px;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: 400;
    /* color: #333333; */
  }
  .analysisContainer .portrait>>>.el-tabs__active-bar{
    background:transparent!important;
  }
  /*达人推荐 */

  .analysisContainer .part6{
        margin-top: 16px;
    }

    .bottemList {
        width: 864px;
        padding: 0 28px;
        background: #FFFFFF;
        border-radius: 6px;
        box-sizing: border-box;
    }

    .bottemList .title {
        width: 100%;
        height: 74px;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #333333;
        line-height: 74px;
    }

    .bottemList .title .titleLeft {
        float: left;
        height: 100%;
    }

    .bottemList .title .titleLeft i {
        color: #FF5500;
    }

    .bottemList .title .titleRight {
        position: relative;
        float: right;
        color: #666666;
        height: 100%;
    }

    .bottemList .title .titleRight .reflesh {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -22px;
        margin: auto 0;
        width: 16px;
        height: 16px;
        background: url("../images/icon_updata.png");
    }

    .bottemList .sameList {
        width: 100%;
        margin-top: 0;
        padding: 0;
        overflow: hidden;
    }

    .bottemList .sameList .top {
        width: 100%;
        height: 54px;
        margin-bottom: 0;
        border: 0;
    }

    .bottemList .sameList li {
        float: left;
        width: 248px;
        height: 264px;
        margin-right: 30px;
        margin-bottom: 30px;
        padding: 24px;
        background: #FFFFFF;
        border: 1px solid #E8E8E8;
        border-radius: 6px;
        box-sizing: border-box;
    }
    .bottemList .sameList li:hover {
        box-shadow:0px 0px 16px rgb(0, 0, 0, .2);
    }
    .bottemList .sameList li a{
        display: block;
    }
    .bottemList .sameList li:nth-of-type(3n) {
        margin-right: 0;
    }

    .bottemList .sameList .top .nameWrap {
        float: left;
        width: 70%;
    }

    .bottemList .sameList .top span {
        display: block;
        margin-bottom: 12px;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }

    .bottemList .sameList .top i {
        display: inline-block;
        margin-left: 0;
        margin-right: 6px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #666666;
    }

    .bottemList .sameList .top .imgWrap {
        float: right;
        width: 54px;
        height: 54px;
        border-radius: 50%;
        overflow: hidden;
    }

    .bottemList .sameList .top .imgWrap img {
        display: block;
        width: 100%;
        height: 100%;
    }

    .bottemList .sameList .center {
        width: 100%;
        overflow: hidden;
    }

    .bottemList .sameList .center .centerItem {
        float: left;
        width: 37%;
        margin-top: 16px;
    }

    .bottemList .sameList .center .centerItem:nth-of-type(3) {
        width: 26%;
    }

    .bottemList .sameList .center .centerItem span {
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #333333;
    }

    .bottemList .sameList .center .centerItem p {
        margin-top: 6px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #666666;
    }

    .bottemList .sameList .tag {
        border-radius: 2px;
        overflow: hidden;
        margin-top: 14px;
        margin-bottom: 14px;
    }

    .bottemList .sameList .tag span {
        background: #FFF2EB;
        float: left;
        height: 24px;
        line-height: 24px;
        margin-right: 10px;
        margin-bottom: 6px;
        padding: 0 10px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #FF5C00;
    }

    .bottemList .sameList .bottem {
        width: 100%;
        height: 20px;
        margin-top: 16px;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 800;
        color: #FF5C00;
    }

    .bottemList .sameList .bottem .price {
        float: left;
    }

    .bottemList .sameList .bottem .other {
        position: relative;
        float: right;
    }

    .bottemList .sameList .bottem .other i {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -20px;
        margin: auto 0;
        width: 16px;
        height: 16px;
        background: url("../images/icon_comunication.png");
    }
    .userTrendsInfo{
      width: 100%;
      height: 320px;
    }
</style>